import { OnionMiddleware } from 'umi-request';
import { isInZhuzher } from '@/utils/env';
import { getToken, initZzeToken, defaultTokenType } from '@/utils/token';
import { IExtraRequestOptions } from '@/services/interface';
/**
 * 添加请求token
 * @param ctx
 * @param next
 */
const addToken: OnionMiddleware = async (ctx, next) => {
  // 如果在住这儿，需要等待jsbridge返回token
  if (isInZhuzher) {
    await initZzeToken.check();
  }
  let tokenType = defaultTokenType;
  const extra: IExtraRequestOptions =
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    ctx.req.options.extraRequestOptions || {};

  if (extra.tokenType) {
    tokenType = extra.tokenType;
  }

  const { headerKey, full } = getToken(tokenType);
  // 存在有效授权的时候添加授权字段
  if (full !== `Bearer `) {
    ctx.req.options.headers = {
      [headerKey]: full,
      // 兼容便民接口
      'access-token': full?.replace('Bearer ', ''),
      ...ctx.req.options.headers,
    };
  }
  await next();
};

export default addToken;
